import { Navigate, Outlet } from "react-router-dom";

const ProtectedAdminRoute = () => {
  const roleName = localStorage.getItem("role_name") || "";
  return roleName?.toLowerCase() === "admin" ? <Outlet /> : <Navigate to="/dashboard" replace />;
};

export default ProtectedAdminRoute;